import { render, staticRenderFns } from "./ClubTrips.vue?vue&type=template&id=5f14479a&"
import script from "./ClubTrips.vue?vue&type=script&lang=js&"
export * from "./ClubTrips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports